export default __webpack_public_path__ + "static/media/img-0400-serbia-premium-face.46b3f33f.png";